import { apiRequest } from "@services/apiClient";

export const fetchClinicUsers = async () => {
  return apiRequest({
    method: "GET",
    endpoint: "/clinic/users",
  });
};

export const createClinicUser = async (payload) => {
  // payload: { email, password, confirm_password, role, permission_preset }
  return apiRequest({
    method: "POST",
    endpoint: "/clinic/users",
    body: payload,
  });
};

export const updateClinicUserAccess = async (userId, payload) => {
  // payload: { role: "DOCTOR"|"STAFF", permission_preset: "CLINICAL"|"FRONTDESK"|"BOTH" }
  return apiRequest({
    method: "POST",
    endpoint: `/clinic/users/${userId}/access`,
    body: payload,
  });
};

export const deleteClinicUser = async (userId) => {
  return apiRequest({
    method: "GET",
    endpoint: `/clinic/users/${userId}`,
  });
};

export const fetchAdminClinics = async () => {
  return apiRequest({
    method: "GET",
    endpoint: "/clinic/clinics",
  });
};

export const updateAdminClinic = async (clinicId, payload) => {
  return apiRequest({
    method: "PATCH",
    endpoint: `/clinic/clinic/${clinicId}`,
    body: payload,
  });
};

export const runSchedulingSetup = async (clinicId) => {
  return apiRequest({
    method: "POST",
    endpoint: `/scheduling/setup/${clinicId}`,
  });
};

export const fetchMyClinicSettings = async () => {
  return apiRequest({
    method: "GET",
    endpoint: "/clinic/my-settings",
  });
};

export const updateMyClinicSettings = async (payload) => {
  // payload: { opening_hours?, welcome_message? }
  return apiRequest({
    method: "PATCH",
    endpoint: "/clinic/my-settings",
    body: payload,
  });
};